"use strict";
// import Phaser from "phaser";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointerManager = void 0;
const constants_1 = __importDefault(require("../shared/constants"));
const equippedSpells_1 = require("./equippedSpells");
class PointerManager {
    constructor(phaserObject, sceneToDrawOn) {
        this.phaserObject = phaserObject;
        this.mainGameScene = this.phaserObject.scene.get(sceneToDrawOn);
        this.fixedPointers = [];
        this.namedPointers = {};
        this.phaserObject.load.image('eventMarker', 'assets/phaserUI/events_exclamation.png', { frameWidth: 22, frameHeight: 22 });
        this.phaserObject.load.image('eventPointer', 'assets/phaserUI/events_pointer.png', { frameWidth: 22, frameHeight: 22 });
        this.phaserObject.load.image('eventRectangle', 'assets/phaserUI/events_square.png', { frameWidth: 22, frameHeight: 22 });
        this.phaserObject.load.image('dungeonGate', 'assets/phaserUI/dungeon_gate.png', { frameWidth: 22, frameHeight: 22 });
    }
    // settings: name (string), despawnTime (int), fixedCoords {x: float, y: float}
    createPointer(iconName, settings, unhidable = false, enginePointer = false) {
        console.log('creating pointer in manager', iconName, settings);
        if (!settings) {
            settings = {};
        }
        const newPointer = this.phaserObject.add.container(0, 0);
        newPointer.unhidable = unhidable;
        newPointer.enginePointer = enginePointer;
        // let newPointer = this.phaserObject.add.container(0, 0)
        newPointer.baseContainer = this.phaserObject.add.container(0, 0);
        newPointer.triangleContainer = this.phaserObject.add.container(0, 0);
        newPointer.add(newPointer.triangleContainer);
        const eventMarker = settings.iconPath ? this.phaserObject.add.sprite(0, 0, 'mainAssets', settings.iconPath) : this.phaserObject.add.sprite(0, 0, iconName);
        eventMarker.displayWidth = 44;
        eventMarker.displayHeight = 44;
        // eventMarker.frameWidth = 220
        // eventMarker.frameHeight = 220
        const eventRectangle = this.phaserObject.add.sprite(0, 0, 'eventRectangle');
        newPointer.baseContainer.add(eventRectangle);
        newPointer.baseContainer.add(eventMarker);
        const eventTriangle = this.phaserObject.add.sprite(eventRectangle.width * .9, 0, 'eventPointer');
        newPointer.triangleContainer.add(eventTriangle);
        newPointer.triangleContainer.eventTriangle = eventTriangle;
        newPointer.eventTriangle = eventTriangle;
        newPointer.setScrollFactor(0);
        newPointer.setDepth(constants_1.default.DEPTHS.UI);
        if (unhidable) {
            newPointer.visible = false;
        }
        // newPointer.active = false
        // newPointer.setScale(0.12)
        // newPointer.baseContainer.setScale(0.7)
        if (settings.name) {
            if (settings.fixedCoords) {
                newPointer.fixedCoords = settings.fixedCoords;
                newPointer.x = settings.fixedCoords.x;
                newPointer.y = settings.fixedCoords.y;
            }
            if (!this.namedPointers[settings.name]) {
                this.namedPointers[settings.name] = newPointer;
                if (settings.despawnTime) {
                    setTimeout(() => {
                        this.namedPointers[settings.name].baseContainer.destroy();
                        this.namedPointers[settings.name].destroy();
                    }, settings.despawnTime);
                }
            }
            else {
                throw Error('Pointer already named');
            }
        }
        else {
            if (settings.fixedCoords) {
                newPointer.fixedCoords = settings.fixedCoords;
                newPointer.x = settings.fixedCoords.x;
                newPointer.y = settings.fixedCoords.y;
                this.fixedPointers.push(newPointer);
                if (settings.despawnTime) {
                    setTimeout(() => {
                        const index = this.fixedPointers.indexOf(newPointer);
                        if (index >= 0) {
                            this.fixedPointers[index].baseContainer.destroy();
                            this.fixedPointers[index].destroy();
                            this.fixedPointers.splice(index, 1);
                        }
                    }, settings.despawnTime);
                }
            }
        }
    }
    removeNamedPointer(name) {
        if (this.namedPointers[name]) {
            console.log('removing pointer', name);
            this.namedPointers[name].baseContainer.destroy();
            this.namedPointers[name].destroy();
            delete this.namedPointers[name];
        }
        else {
            console.log('Pointer does not exist', name);
        }
    }
    hidePointers() {
        console.log('hiding pointers');
        for (let i = 0; i < this.fixedPointers.length; i++) {
            if (!this.fixedPointers[i].unhidable) {
                this.fixedPointers[i].visible = false;
                this.fixedPointers[i].baseContainer.visible = false;
            }
        }
        for (const [key, value] of Object.entries(this.namedPointers)) {
            if (!this.namedPointers[key].unhidable) {
                this.namedPointers[key].visible = false;
                this.namedPointers[key].baseContainer.visible = false;
            }
        }
    }
    removeAllCustomNamedPointers() {
        for (const [key, value] of Object.entries(this.namedPointers)) {
            if (!this.namedPointers[key].enginePointer) {
                this.removeNamedPointer(key);
            }
        }
    }
    updateFixedPointers(player) {
        // console.log('fixed pointers', this.fixedPointers)
        for (let i = 0; i < this.fixedPointers.length; i++) {
            this.updatePointer(player, this.fixedPointers[i].fixedCoords, this.fixedPointers[i]);
        }
    }
    updateNamedPointer(name, player, coords) {
        if (!coords) {
            coords = this.namedPointers[name].fixedCoords;
        }
        const namedPointer = this.namedPointers[name];
        if (namedPointer) {
            // console.log('named pointer', namedPointer)
            this.updatePointer(player, coords, namedPointer);
        }
        else {
            console.warn('Pointer does not exist', name);
        }
    }
    updatePointer(player, coords, pointer) {
        // console.log('updating pointer', pointer)
        const displayWidth = this.mainGameScene.cameras.main.displayWidth;
        const displayHeight = this.mainGameScene.cameras.main.displayHeight;
        // let scaleFactor = this.calculateScaleFactor(displayWidth, displayHeight)
        const cameraX = player.x - (displayWidth / 2);
        // let uiDistance = 0.5
        // let uiDistance = 0.65
        const uiDistance = 0.8;
        let newX, newY;
        const xPos = (coords.x - cameraX) * this.mainGameScene.cameras.main.zoom;
        if (xPos < 0 + (uiDistance * displayWidth)) {
            pointer.x = 0 + (displayWidth * uiDistance);
            newX = (displayWidth * uiDistance);
        }
        else if (xPos > this.phaserObject.scale.width - pointer.width - (uiDistance * displayWidth)) {
            pointer.x = this.phaserObject.scale.width - pointer.width - (displayWidth * uiDistance);
            newX = this.phaserObject.scale.width - pointer.width - (displayWidth * uiDistance);
        }
        else {
            pointer.x = xPos;
            newX = xPos;
        }
        const cameraY = player.y - (displayHeight / 2);
        const yPos = (coords.y - cameraY) * this.mainGameScene.cameras.main.zoom;
        if (yPos < 0 + (uiDistance * displayHeight)) {
            pointer.y = 0 + (displayHeight * uiDistance);
            newY = 0 + (displayHeight * uiDistance);
        }
        else if (yPos > this.phaserObject.scale.height - pointer.height - (uiDistance * displayHeight)) {
            pointer.y = this.phaserObject.scale.height - pointer.height - (displayHeight * uiDistance);
            newY = this.phaserObject.scale.height - pointer.height - (displayHeight * uiDistance);
        }
        else {
            pointer.y = yPos;
            newY = yPos;
        }
        // console.log('scale factor', scaleFactor)
        pointer.setPosition(newX, newY);
        pointer.baseContainer.setPosition(newX, newY);
        // pointer.setScale(scaleFactor)
        // pointer.baseContainer.setScale(scaleFactor)
        if ((yPos < this.phaserObject.scale.height - pointer.height) && (yPos > 0)
            && ((xPos < (this.phaserObject.scale.width - pointer.width)) && (xPos > 0))) {
            pointer.visible = false;
            pointer.baseContainer.visible = false;
        }
        else {
            if (equippedSpells_1.loaded) {
                pointer.visible = true;
                pointer.baseContainer.visible = true;
            }
        }
        const containerXDiff = (pointer.x / this.mainGameScene.cameras.main.zoom) - (displayWidth / 2);
        const containerYDiff = (pointer.y / this.mainGameScene.cameras.main.zoom) - (displayHeight / 2);
        pointer.triangleContainer.rotation = Phaser.Math.Angle.Between(player.x + containerXDiff, player.y + containerYDiff, coords.x, coords.y);
    }
}
exports.PointerManager = PointerManager;
